// The portal's i18next instance: the platform catalogues plus the portal's own namespace, `player`,
// all from `@clavian/i18n` (copy lives there and nowhere else, spec/21 §3).

import { createI18n, resolveLocale, type CreateI18nOptions, type VenueLocale } from '@clavian/i18n';
import { playerWebResources } from '@clavian/i18n/player-web';
import { initReactI18next } from '@clavian/i18n/react';

export type PlayerI18n = ReturnType<typeof createI18n>;

export function createPlayerI18n(
  language?: string,
  resources: NonNullable<CreateI18nOptions['extraResources']> = playerWebResources,
): PlayerI18n {
  const preferred = language ?? (typeof navigator === 'undefined' ? undefined : navigator.language);
  return createI18n({ language: resolveLocale(preferred), extraResources: resources, use: [initReactI18next] });
}

/**
 * Money, dates and business days follow the venue (spec/12 §7). Until a screen knows a particular
 * venue's currency, the portal's frame uses the launch market's defaults (spec/03 §10: INR, en-IN,
 * Asia/Kolkata) — the same default the console carries.
 */
export const DEFAULT_VENUE_LOCALE: VenueLocale = { locale: 'en-IN', timeZone: 'Asia/Kolkata', currency: 'INR' };
